import React from 'react';
import PropTypes from 'prop-types';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import styles from './AutoRefresh.module.css';
const { Switch } = MaterialUiCore;
let refreshInterval = [];
let refreshTimeout = [];
let lastUpdatedInterval;
let isFocusAuto = false;
const startTime = Date.now();

const AutoRefresh = ({ autoFuncs, refresh, updateFormat, focusEnabled }) => {
    const [isAuto, setIsAuto] = React.useState(false);
    const [lastUpdated, setLastUpdated] = React.useState(-1);

    const funcInterval = (t1, t2, tInt) => {
        const diff = t2 - t1;
        const quo = diff % tInt;
        return tInt - quo;
    };

    const autoClicked = (e, autoVal, isRefresh, isFocus) => {
        isFocusAuto = autoVal;
        setIsAuto(autoVal);

        if (!isRefresh) {
            setLastUpdated(0);
        }

        if (autoVal) {
            if (typeof lastUpdatedInterval !== 'undefined') clearInterval(lastUpdatedInterval);
            autoFuncs.forEach((ele) => {
                if (isFocus) {
                    const currentTime = Date.now();
                    const timeLeft = funcInterval(startTime, currentTime, ele.autoInterval);
                    const autoTimeout = setTimeout(() => {
                        ele.autoFunc();
                    }, timeLeft);
                    refreshTimeout.push(autoTimeout);
                }

                const autoInt = setInterval(() => {
                    ele.autoFunc();
                }, ele.autoInterval);
                refreshInterval.push(autoInt);
            });
        } else if (!isRefresh) {
            clearRefresh();
            lastUpdatedInterval = setInterval(
                () => {
                    setLastUpdated((preV) => preV + 1);
                },
                updateFormat === 'hr' ? 3600000 : 60000,
            );
        }
    };

    const getLastUpdated = () => {
        if (updateFormat === 'hr') {
            return lastUpdated + (lastUpdated > 1 ? ' hrs' : ' hr');
        }

        if (lastUpdated < 60) {
            return lastUpdated + (lastUpdated > 1 ? ' mins' : ' min');
        }

        const hrs = Math.floor(lastUpdated / 60);
        const mins = lastUpdated % 60;
        return hrs + (hrs > 1 ? ' hrs ' : ' hr ') + mins + (mins > 1 ? ' mins' : ' min');
    }; // User has switched back to the tab

    const onFocus = () => {
        autoClicked(null, isFocusAuto, true, true);
    }; // User has switched away from the tab

    const onBlur = () => {
        clearRefresh();
    }; // clear window objects

    const clearRefresh = () => {
        if (typeof refreshInterval !== 'undefined' && refreshInterval.length > 0) {
            refreshInterval.forEach((ele) => {
                clearInterval(ele);
            });
            refreshInterval = [];
        }

        if (typeof refreshTimeout !== 'undefined' && refreshTimeout.length > 0) {
            refreshTimeout.forEach((ele) => {
                clearTimeout(ele);
            });
            refreshTimeout = [];
        }
    };

    React.useEffect(() => {
        autoClicked(null, refresh, true);

        if (focusEnabled) {
            window.addEventListener('focus', onFocus);
            window.addEventListener('blur', onBlur);
        }

        return () => {
            clearRefresh();
            if (typeof lastUpdatedInterval !== 'undefined') clearInterval(lastUpdatedInterval);

            if (focusEnabled) {
                window.removeEventListener('focus', onFocus);
                window.removeEventListener('blur', onBlur);
            }
        };
    }, []);
    return (
        <div className={styles.refreshContainer}>
            <div className={styles.btnContainer}>
                <Switch checked={isAuto} onChange={autoClicked} name="autoRefresh" />
                <span className={styles.refLabel}>Auto Refresh</span>
            </div>
            {lastUpdated > -1 && !isAuto && (
                <span className={styles.updateLabel}>Last updated {getLastUpdated()} ago</span>
            )}
        </div>
    );
};

AutoRefresh.propTypes = {
    autoFuncs: PropTypes.array.isRequired,
    refresh: PropTypes.bool,
    focusEnabled: PropTypes.bool,
    updateFormat: PropTypes.string,
};
AutoRefresh.defaultProps = {
    refresh: false,
    updateFormat: 'hr',
    focusEnabled: false,
};
export default AutoRefresh;
